export const validationAMLCliente = (aml, urlParamsAml, documents = []) => {
  const cliente = aml || {};
  const errors = [];

  if (urlParamsAml === "giuridico-ita" || urlParamsAml === "giuridico-eng") {
    const company = cliente.company || {};

    if (!company.name) errors.push("company.name");
    if (!company.tax_code) errors.push("company.tax_code");
    if (!company.vat) errors.push("company.vat");
    if (!company.address) errors.push("company.address");
    if (!company.zip) errors.push("company.zip");
    if (!company.city) errors.push("company.city");
    if (!company.province) errors.push("company.province");
    if (!company.country) errors.push("company.country");
    if (!company.register) errors.push("company.register");
    if (!company.registration_number)
      errors.push("company.registration_number");
    if (!company.rea) errors.push("company.rea");
    if (!company.email) errors.push("company.email");
    if (!company.pec) errors.push("company.pec");

    // ── Controllo upload camerale ──
    const isEng = urlParamsAml === "giuridico-eng";
    const baseName = (d) =>
      d.assigned_name?.split(".")[0] ?? d.original_name?.split(".")[0];
    const cameraleKey = isEng ? "client_company_register" : "cliente_camerale";
    if (!documents.some((d) => baseName(d) === cameraleKey))
      errors.push("company.camerale.upload");
  } else {
    const client = cliente.client || {};
    const residence = client.residence || {};
    const domicile = client.domicile || {};
    const document = client.document || {};

    if (!client.first_name) errors.push("client.first_name");
    if (!client.last_name) errors.push("client.last_name");
    if (!client.birth_place) errors.push("client.birth_place");
    if (!client.birth_date) errors.push("client.birth_date");
    if (!client.tax_code) errors.push("client.tax_code");
    if (!client.profession) errors.push("client.profession");
    if (!client.email) errors.push("client.email");
    if (!client.pec) errors.push("client.pec");

    if (!residence.address) errors.push("client.residence.address");
    if (!residence.zip) errors.push("client.residence.zip");
    if (!residence.city) errors.push("client.residence.city");
    if (!residence.province) errors.push("client.residence.province");
    if (!residence.country) errors.push("client.residence.country");

    if (client.domicile_same === "" || client.domicile_same == null) {
      errors.push("client.domicile_same");
    }

    if (client.domicile_same === false) {
      if (!domicile.address) errors.push("client.domicile.address");
      if (!domicile.zip) errors.push("client.domicile.zip");
      if (!domicile.city) errors.push("client.domicile.city");
      if (!domicile.province) errors.push("client.domicile.province");
      if (!domicile.country) errors.push("client.domicile.country");
    }

    if (!document.type) errors.push("client.document.type");
    if (!document.number) errors.push("client.document.number");
    if (!document.issuer) errors.push("client.document.issuer");
    if (!document.issue_date) errors.push("client.document.issue_date");
    if (!document.expiry_date) errors.push("client.document.expiry_date");

    if (client.is_pep === "" || client.is_pep == null) {
      errors.push("client.is_pep");
    }
    if (client.is_pep === true) {
      if (!client.pep_role) errors.push("client.pep_role");
    }

    // ── Controllo upload documento ──
    const isEng = urlParamsAml === "fisico-eng";
    const docType = document.type;
    const baseName = (d) =>
      d.assigned_name?.split(".")[0] ?? d.original_name?.split(".")[0];

    if (docType === "Carta d'identità") {
      const frontKey = isEng
        ? "client_identity_card_front"
        : "cliente_carta_identita_fronte";
      const backKey = isEng
        ? "client_identity_card_back"
        : "cliente_carta_identita_retro";
      if (!documents.some((d) => baseName(d) === frontKey))
        errors.push("client.document.upload_front");
      if (!documents.some((d) => baseName(d) === backKey))
        errors.push("client.document.upload_back");
    } else if (docType === "Patente di guida") {
      const key = isEng ? "client_driving_license" : "cliente_patente";
      if (!documents.some((d) => baseName(d) === key))
        errors.push("client.document.upload");
    } else if (docType === "Passaporto") {
      const key = isEng ? "client_passport" : "cliente_passaporto";
      if (!documents.some((d) => baseName(d) === key))
        errors.push("client.document.upload");
    }
  }

  return errors;
};

export const validationAMLEsecutore = (aml, urlParamsAml, documents = []) => {
  const isFisico =
    urlParamsAml === "fisico-ita" || urlParamsAml === "fisico-eng";

  if (isFisico) {
    if (aml?.has_executor === "" || aml?.has_executor == null) {
      return ["has_executor"];
    }
    if (aml?.has_executor === false) {
      return [];
    }
  }

  const executor = aml?.executor || {};
  const residence = executor?.residence || {};
  const domicile = executor?.domicile || {};
  const document = executor?.document || {};
  const errors = [];

  if (!executor.first_name) errors.push("executor.first_name");
  if (!executor.last_name) errors.push("executor.last_name");
  if (!executor.birth_place) errors.push("executor.birth_place");
  if (!executor.birth_date) errors.push("executor.birth_date");
  if (!executor.tax_code) errors.push("executor.tax_code");
  if (!executor.role) errors.push("executor.role");

  if (!residence.address) errors.push("executor.residence.address");
  if (!residence.zip) errors.push("executor.residence.zip");
  if (!residence.city) errors.push("executor.residence.city");
  if (!residence.province) errors.push("executor.residence.province");
  if (!residence.country) errors.push("executor.residence.country");

  if (executor.domicile_same === "" || executor.domicile_same == null) {
    errors.push("executor.domicile_same");
  } else if (executor.domicile_same === false) {
    if (!domicile.address) errors.push("executor.domicile.address");
    if (!domicile.zip) errors.push("executor.domicile.zip");
    if (!domicile.city) errors.push("executor.domicile.city");
    if (!domicile.province) errors.push("executor.domicile.province");
    if (!domicile.country) errors.push("executor.domicile.country");
  }

  if (!executor.email) errors.push("executor.email");
  if (!executor.pec) errors.push("executor.pec");

  if (!executor.representation_document)
    errors.push("executor.representation_document");

  if (!document.type) errors.push("executor.document.type");
  if (!document.number) errors.push("executor.document.number");
  if (!document.issuer) errors.push("executor.document.issuer");
  if (!document.issue_date) errors.push("executor.document.issue_date");
  if (!document.expiry_date) errors.push("executor.document.expiry_date");

  if (executor.is_pep === "" || executor.is_pep == null) {
    errors.push("executor.is_pep");
  } else if (executor.is_pep === true) {
    if (!executor.pep_role) errors.push("executor.pep_role");
  }

  // ── Controllo upload documento rappresentanza ──
  const isEng =
    urlParamsAml === "fisico-eng" || urlParamsAml === "giuridico-eng";
  const baseName = (d) =>
    d.assigned_name?.split(".")[0] ?? d.original_name?.split(".")[0];

  const reprKey = isEng
    ? "executor_representation_document"
    : "esecutore_documento_rappresentanza";
  if (!documents.some((d) => baseName(d) === reprKey))
    errors.push("executor.representation_document.upload");

  // ── Controllo upload documento identità ──
  const docType = document.type;

  if (docType === "Carta d'identità") {
    const frontKey = isEng
      ? "executor_identity_card_front"
      : "esecutore_carta_identita_fronte";
    const backKey = isEng
      ? "executor_identity_card_back"
      : "esecutore_carta_identita_retro";
    if (!documents.some((d) => baseName(d) === frontKey))
      errors.push("executor.document.upload_front");
    if (!documents.some((d) => baseName(d) === backKey))
      errors.push("executor.document.upload_back");
  } else if (docType === "Patente di guida") {
    const key = isEng ? "executor_driving_license" : "esecutore_patente";
    if (!documents.some((d) => baseName(d) === key))
      errors.push("executor.document.upload");
  } else if (docType === "Passaporto") {
    const key = isEng ? "executor_passport" : "esecutore_passaporto";
    if (!documents.some((d) => baseName(d) === key))
      errors.push("executor.document.upload");
  }

  return errors;
};

export const validationAMLTitolare = (aml, urlParamsAml) => {
  const errors = [];

  if (aml?.has_beneficial_owner === "" || aml?.has_beneficial_owner == null) {
    errors.push("has_beneficial_owner");
    return errors;
  }

  if (aml?.has_beneficial_owner === false) return [];

  const owners = aml?.beneficial_owners || [];
  if (owners.length === 0) {
    errors.push("titolari");
    return errors;
  }

  return errors;
};

export const validationAMLSingleTitolare = (
  titolare,
  documents = [],
  idx = 0,
  urlParamsAml = "",
) => {
  const residence = titolare?.residence || {};
  const domicile = titolare?.domicile || {};
  const document = titolare?.document || {};
  const errors = [];

  if (!titolare.first_name) errors.push("first_name");
  if (!titolare.last_name) errors.push("last_name");
  if (!titolare.birth_place) errors.push("birth_place");
  if (!titolare.birth_date) errors.push("birth_date");
  if (!titolare.tax_code) errors.push("tax_code");
  if (!titolare.profession) errors.push("profession");

  if (!residence.address) errors.push("residence.address");
  if (!residence.zip) errors.push("residence.zip");
  if (!residence.city) errors.push("residence.city");
  if (!residence.province) errors.push("residence.province");
  if (!residence.country) errors.push("residence.country");

  if (titolare.domicile_same === "" || titolare.domicile_same == null) {
    errors.push("domicile_same");
  } else if (titolare.domicile_same === false) {
    if (!domicile.address) errors.push("domicile.address");
    if (!domicile.zip) errors.push("domicile.zip");
    if (!domicile.city) errors.push("domicile.city");
    if (!domicile.province) errors.push("domicile.province");
    if (!domicile.country) errors.push("domicile.country");
  }

  if (!titolare.email) errors.push("email");
  if (!titolare.pec) errors.push("pec");

  if (!document.type) errors.push("document.type");
  if (!document.number) errors.push("document.number");
  if (!document.issuer) errors.push("document.issuer");
  if (!document.issue_date) errors.push("document.issue_date");
  if (!document.expiry_date) errors.push("document.expiry_date");

  if (!titolare.qualification_reason) errors.push("qualification_reason");

  if (titolare.is_pep === "" || titolare.is_pep == null) {
    errors.push("is_pep");
  } else if (titolare.is_pep === true) {
    if (!titolare.pep_role) errors.push("pep_role");
  }

  // ── Controllo upload documento ──
  const isEng =
    urlParamsAml === "fisico-eng" || urlParamsAml === "giuridico-eng";
  const baseName = (d) =>
    d.assigned_name?.split(".")[0] ?? d.original_name?.split(".")[0];
  const docType = document.type;

  if (docType === "Carta d'identità") {
    const frontKey = isEng
      ? `beneficial_owner_${idx}_identity_card_front`
      : `titolare_${idx}_carta_identita_fronte`;
    const backKey = isEng
      ? `beneficial_owner_${idx}_identity_card_back`
      : `titolare_${idx}_carta_identita_retro`;
    if (!documents.some((d) => baseName(d) === frontKey))
      errors.push("document.upload_front");
    if (!documents.some((d) => baseName(d) === backKey))
      errors.push("document.upload_back");
  } else if (docType === "Patente di guida") {
    const key = isEng
      ? `beneficial_owner_${idx}_driving_license`
      : `titolare_${idx}_patente`;
    if (!documents.some((d) => baseName(d) === key))
      errors.push("document.upload");
  } else if (docType === "Passaporto") {
    const key = isEng
      ? `beneficial_owner_${idx}_passport`
      : `titolare_${idx}_passaporto`;
    if (!documents.some((d) => baseName(d) === key))
      errors.push("document.upload");
  }

  return errors;
};

export const validationAMLPrestazione = (aml, urlParamsAml) => {
  const service = aml?.service || {};
  const errors = [];

  if (!service.nature) errors.push("service.nature");
  if (service.nature === "other" && !service.nature_other) errors.push("service.nature_other");
  if (!service.payment_method) errors.push("service.payment_method");
  if (!service.funds_source) errors.push("service.funds_source");
  if (service.funds_source === "other" && !service.funds_source_other) errors.push("service.funds_source_other");

  return errors;
};
